import { useContext } from "react";
import { LogOut } from "lucide-react";

import Avatar from "@components/ui-components/avatar";
import { Dropdown, DropdownItem } from "@components/ui-components/dropdown";
import { UserContext } from "@context/user";
import useLogout from "@hooks/use-logout";

export const CommonNavOptions = () => {
  const { handleLogout } = useLogout();

  return [
    {
      id     : "log-out",
      title  : "Logout",
      icon   : LogOut,
      tag    : "div",
      show   : true,
      onClick: handleLogout
    }
  ];
};

export const PanelUserDropdown = () => {
  const { userData: { user: { name, image, email } = {} } = {} } =
    useContext(UserContext);
  return (
    <Dropdown
      data-cy="user-dropdown"
      className="flex items-center"
      trigger={
        <a href="/" className="block" onClick={(e) => e.preventDefault()}>
          <Avatar
            img={image}
            initials={!image}
            content={name || email || "User"}
            color="primary"
            light={false}
            className="cursor-pointer"
            rounded
          />
        </a>
      }
    >
      {CommonNavOptions().map((option) => {
        const Icon = option.icon;
        return (
          option.show && (
            <DropdownItem
              onClick={option.onClick}
              data-cy={`${option.id}-btn`}
              key={option.id}
            >
              <Icon size={18} className="mr-3" />
              {option.title}
            </DropdownItem>
          )
        );
      })}
    </Dropdown>
  );
};
